import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {motion} from 'framer-motion';

const StyledContainer = styled(motion.div)`
  color: inherit;
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
  justify-content: ${props => props.justifyContent};
  background-color: #f5f5f5;
`;

function Container({children, loggedIn, ...rest}) {
  return (
    <StyledContainer
      {...rest}
      initial="hidden"
      animate="visible"
      variants={{
        hidden: {
          opacity: 0,
        },
        visible: {
          opacity: 1,
          transition: {
            delay: 0.1,
          },
        },
      }}>
      {children}
    </StyledContainer>
  );
}

Container.propTypes = {
  /**
   * Text, component or node
   */
  children: PropTypes.node.isRequired,

  /**
   *
   */
  loggedIn: PropTypes.bool,

  /**
   * Alignment of child nodes
   */
  justifyContent: PropTypes.oneOf([
    'center',
    'normal',
    'flex-start',
    'flex-end',
  ]),
};

Container.defaultProps = {
  loggedIn: false,
  justifyContent: 'normal',
};

export default Container;
